<div class="aems-bread-crumb m-b-16">
  <a class="m-r-4" routerLink="/workorders">Work Orders</a><span>/ {{ id }}</span>
</div>
<div class="m-b-12" style="display: flex; align-items: center; gap: 12px">
  <h3>Work Order-{{ id }}</h3>
  <mc-tag fit="small" data-cy="workorderStatus" [label]="workOrderStatus()" appearance="info"> </mc-tag>
  @if (workOrder?.reeferContainerCondition === 'BOX_OK') {
    <mc-tag fit="small" icon="check-circle" appearance="success" label="BOX OK"> </mc-tag>
  }
  @if (workOrder?.reeferContainerCondition === 'MAC_OK') {
    <mc-tag fit="small" icon="check-circle" appearance="success" label="MAC OK"> </mc-tag>
  }

  <div style="display: flex; flex-grow: 1; justify-content: end; gap: 8px">
    @if (workOrder?.maintenanceOrderStatusCode === 390 && authPolicy.canEditWorkOrder) {
      <mc-button
        data-cy="mark-complete"
        fit="small"
        (click)="onMarkCompleteClicked()"
        [disabled]="markAsCompleteAPICallStatus === 'IN_PROGRESS'"
        [loading]="markAsCompleteAPICallStatus == 'IN_PROGRESS'"
        >Mark Complete</mc-button
      >
    }
    @if (
      [10, 100, 200, 330, 340, 390].includes(workOrder?.maintenanceOrderStatusCode ?? 0) &&
      authPolicy.canEditWorkOrder &&
      workOrder?.maintenanceOrderSourceApplication !== 'MNR' &&
      workOrder?.maintenanceOrderSourceApplication !== 'eEIR' &&
      workOrder?.maintenanceOrderSourceApplication !== 'Vessel-WorkOrder-Upload-Job'
    ) {
      <mc-button data-cy="edit" fit="small" variant="outlined" icon="pencil" (click)="onEditClicked()">Edit</mc-button>
    }
    @if (authPolicy.canViewWorkOrderAuditLog && workOrder) {
      <mc-button
        data-cy="audit-log"
        fit="small"
        variant="outlined"
        icon="arrow-anti-clockwise-clock"
        [loading]="auditlogApiCallStatus === 'IN_PROGRESS'"
        [disabled]="workOrder.maintenanceOrderStatusCode === 10"
        (click)="onAuditLogClicked()"
        (keydown)="onAuditLogClicked()">
        Audit Log
      </mc-button>
    }
    @if (workOrder) {
      <mc-button
        data-cy="print"
        fit="small"
        variant="outlined"
        icon="printer"
        (click)="onPrintClicked()"
        (keydown.enter)="onPrintClicked()">
      </mc-button>
    }
  </div>
</div>
@if (viewDataApiCalls === 'COMPLETED_SUCCESFULLY') {
  @if (workOrder) {
    <app-work-order-header [workOrderHeader]="workOrder" [gensetHours]="gensetHours"></app-work-order-header>
  }

  @if (equipment) {
    <app-cwo-container-details
      [equipment]="equipment"
      [shopLocationCode]="workOrder?.locationCode"
      [mode]="mode.code"></app-cwo-container-details>
  }
  <!--Show Alarms components only when alarms are present -->
  @if ((equipment?.alarms?.length ?? -1 > 0) && mode.damageType == 1) {
    <app-cwo-alarm-details [equipment]="equipment"></app-cwo-alarm-details>
  }
  @if (workOrder && workOrder.maintenanceOrderLines && blobFilesResolved()) {
    <div class="m-t-12">
      <app-list-repair-line-items
        [data]="workOrder.maintenanceOrderLines"
        [maintainceOrderStatus]="workOrder.maintenanceOrderStatusCode"
        [maintenanceOrderSourceApplication]="workOrder.maintenanceOrderSourceApplication"
        [workOrderMode]="workOrder.maintenanceRepairModeCode ?? ''"
        shopCurrency="NA"></app-list-repair-line-items>
    </div>
  }
  @if (workOrder?.blobResolvedFiles?.length ?? -1 > 0) {
    <div class="aems-card m-t-12">
      <p class="mds-content"><strong>Attachments</strong></p>
      <hr class="m-b-12" />
      <app-file-upload
        type="full"
        [readOnly]="true"
        [inputFiles]="workOrder?.blobResolvedFiles ?? []"
        [workOrderMode]="workOrder?.maintenanceRepairModeCode ?? ''"
        [inspectionDetailsWithLine]="undefined">
      </app-file-upload>
    </div>
  }
  @if (totalCost) {
    <div class="m-t-12">
      <app-cwo-total-cost [cost]="totalCost" [totalManHoursSummary]="totalManHoursSummary" [workOrderMode]="'view'"></app-cwo-total-cost>
    </div>
  }
  <div class="m-t-12">
    <app-cwo-remarks
      [workOrderId]="id"
      [workOrderRemarks]="workOrder?.maintenanceOrderRemarks ?? []"
      [workOrderMode]="'view'"
      (remarkAdded)="getGensetHours($event)"></app-cwo-remarks>
  </div>
  <div class="m-t-12" style="display: flex; justify-content: end; gap: 16px">
    <mc-button fit="medium" variant="outlined" (click)="onBackClicked()">Back</mc-button>
    @if (canShowDeleteButton) {
      <mc-button data-cy="delete" fit="medium" variant="outlined" (click)="onDeleteClicked()">Delete</mc-button>
    }
    @if (workOrder?.maintenanceOrderStatusCode == suspendForTTLCheckStatus && authPolicy.canMarkWorkOrderAsTTL) {
      <mc-button
        data-cy="reject-as-ttl"
        fit="medium"
        appearance="primary"
        [loading]="rejectAsTtlApiCallStatus === 'IN_PROGRESS'"
        (click)="onRejectClicked()"
        >Reject</mc-button
      >
      <mc-button data-cy="mark-ttl" fit="medium" [loading]="markAsCompleteAPICallStatus === 'IN_PROGRESS'" (click)="onMarkTTLClicked()">
        Mark as TTL
      </mc-button>
    }
  </div>
}

@if (viewDataApiCalls === 'IN_PROGRESS') {
  <div class="aems-card m-t-36">
    <div class="pure-g">
      @for (x of '1234567890'; track $index) {
        <div class="pure-u-md-8-24 pure-u-lg-4-24 p-b-16 p-r-8">
          <app-loader height="40px"></app-loader>
        </div>
      }
    </div>
  </div>
  <div class="aems-card m-t-12">
    <p class="mds-content"><strong>Equipment Details</strong></p>
    <hr class="m-b-12" />
    <div class="pure-g">
      @for (x of '123456789012345'; track $index) {
        <div class="pure-u-md-8-24 pure-u-lg-4-24 p-b-16 p-r-8">
          <app-loader height="40px"></app-loader>
        </div>
      }
    </div>
  </div>
  <div class="aems-card m-t-12">
    <div class="pure-g">
      @for (x of '123456789'; track $index) {
        @for (x of '12345678'; track $index) {
          <div class="pure-u-md-3-24 pure-u-lg-3-24 p-b-16 p-r-8">
            <app-loader></app-loader>
          </div>
        }
      }
    </div>
  </div>
}
<mc-modal
  hiddenclose
  backdropcloseactiondisabled
  [heading]="workOrder?.maintenanceOrderStatusCode === 10 ? 'Delete draft work order' : 'Delete work order'"
  fit="small"
  dimension="small"
  [open]="openDeleteWorkOrderConfirmation"
  (closed)="onDeleteWorkOrderConfirmationClosed()">
  @if (deleteApiCallStatus === 'NOT_STARTED') {
    <p style="font-size: 0.8rem">{{ deleteConfirmationMessage }}</p>
  }
  @if (deleteApiCallStatus === 'IN_PROGRESS') {
    <p style="font-size: 0.8rem">Deleting workorder...</p>
  }
  @if (deleteApiCallStatus === 'COMPLETED_SUCCESFULLY') {
    <p>Workorder deleted !</p>
    <p>Taking you back to list page..</p>
  }
  @if (deleteApiCallStatus !== 'COMPLETED_SUCCESFULLY') {
    @if (deleteApiCallStatus !== 'IN_PROGRESS') {
      <mc-button slot="secondaryAction" dialogaction="cancel" appearance="neutral" variant="outlined">Cancel</mc-button>
    }
    <mc-button
      slot="primaryAction"
      appearance="primary"
      [loading]="deleteApiCallStatus === 'IN_PROGRESS'"
      (click)="onDeleteWorkOrderConfirmed()"
      >Yes</mc-button
    >
  }
</mc-modal>
<mc-modal backdropcloseactiondisabled heading="Audit Log" fit="medium" [open]="openAuditLog" (closed)="onAuditLogClosed()">
  @if (openAuditLog) {
    <app-audit-log [auditLog]="auditLog" [workOrder]="workOrder" [newAuditLogData]="newAuditLogData"></app-audit-log>
  }
</mc-modal>

<mc-modal
  backdropcloseactiondisabled
  heading="Audit Log"
  fit="small"
  dimension="large"
  [open]="openNewAuditLog"
  (closed)="onNewAuditLogClosed()">
  @if (openNewAuditLog) {
    <app-aems-audit-log [workOrder]="workOrder"></app-aems-audit-log>
  }
</mc-modal>

@if (workOrder) {
  <app-print-dialog [open]="openPrintDialog" (closed)="openPrintDialog = false" (printConfirmed)="onPrintConfirmed($event)">
  </app-print-dialog>
  <app-print-work-order
    [workOrder]="workOrder"
    [equipment]="equipment"
    [totalCost]="totalCost"
    [gensetHours]="gensetHours"
    [workOrderId]="id"
    [workOrderStatus]="workOrderStatus()"
    [totalManHoursSummary]="totalManHoursSummary"
    [includeRemarks]="includeRemarksInPrint">
  </app-print-work-order>
}
<mc-modal heading="Mark As TTL" fit="small" dimension="small" [open]="openMarkAsTTLConfirmation" (closed)="onMarkAsTTLConfirmationClosed()">
  <p style="font-size: 0.8rem">Are you sure to mark it as total loss?</p>
  <mc-button slot="secondaryAction" dialogaction="cancel" appearance="neutral" variant="outlined" (click)="onMarkAsTTLConfirmationCancel()"
    >Cancel</mc-button
  >
  <mc-button slot="primaryAction" appearance="primary" (click)="onMarkAsTTLConfirmationDone()">Yes</mc-button>
</mc-modal>
